import React from "react";
import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { Button } from "react-admin";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ModalTitle, {
  modalCancelButtonSx,
  modalConfirmButtonSx,
  modalContentSx,
  withModalSx,
} from "server/components/Modals/ModalTitle";
import { AdministrationServicePath, HEALTH_INSURANCES } from "utils/constants";

// Shown when the HealthInsurance report fails with EC_MissingHealthInsuranceConfig - no health insurance
// (amount + percentage) is configured for the chosen period, so the report has nothing to compute with.
const MissingHealthInsuranceDialog = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    sx={withModalSx()}
  >
    <ModalTitle
      icon={<ErrorOutlineIcon />}
      title="Липсва здравно осигуряване"
      color="error"
    />
    <DialogContent
      dividers
      sx={modalContentSx}
    >
      <Typography>Няма съществуващо здравно осигуряване за този период.</Typography>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="outlined"
        color="error"
        size="medium"
        label="Затвори"
        sx={modalCancelButtonSx}
      />
      {/* component={Link} renders the button as a router link, so `to` navigates. */}
      <Button
        component={Link}
        to={`/${AdministrationServicePath}${HEALTH_INSURANCES}/create`}
        variant="contained"
        size="medium"
        label="Създайте здравна осигуровка"
        sx={modalConfirmButtonSx}
      >
        <AddIcon />
      </Button>
    </DialogActions>
  </Dialog>
);

export default MissingHealthInsuranceDialog;
